window.preSelectNormalOrderVariant = function () {
  const LOG = true;
  // function log(...args){ if (LOG) console.log('[preSelectNormalOrderVariant]', ...args); }
  function log(...args){ if (LOG) return; }

  function dispatchNativeEvent(el, type) {
    try {
      const ev = new Event(type, { bubbles: true, cancelable: true });
      el.dispatchEvent(ev);
      log('dispatched', type, 'on', el);
    } catch (e) {
      console.warn('[preSelectNormalOrderVariant] could not dispatch', type, e);
    }
  }
  function dispatchMouseClick(el) {
    try {
      const me = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
      el.dispatchEvent(me);
      log('dispatched MouseEvent click on', el);
    } catch (e) {
      console.warn('[preSelectNormalOrderVariant] mouse click failed', e);
    }
  }

  function tryTrigger(inputEl) {
    if (!inputEl) return false;
    log('found input', inputEl, 'initial checked:', !!inputEl.checked);

    // try label first (themes often bind to label)
    const id = inputEl.id;
    let label = id ? document.querySelector('label[for="' + id + '"]') : null;
    if (!label) label = inputEl.closest('label') || inputEl.parentElement.querySelector('label');

    if (label) {
      log('clicking label to trigger handlers', label);
      dispatchMouseClick(label);
    }

    // Force checked change (uncheck then check) to force change listeners
    try {
      if (inputEl.checked) {
        inputEl.checked = false;
        dispatchNativeEvent(inputEl, 'input');
        dispatchNativeEvent(inputEl, 'change');
      }
      inputEl.checked = true;
      // Dispatch multiple events to cover all listeners
      dispatchMouseClick(inputEl);
      dispatchNativeEvent(inputEl, 'input');
      dispatchNativeEvent(inputEl, 'change');
    } catch (e) {
      console.warn('[preSelectNormalOrderVariant] toggle checked error', e);
    }

    // jQuery fallback triggers if available
    if (window.jQuery) {
      try {
        const $i = jQuery(inputEl);
        $i.prop('checked', true);
        $i.trigger('input');
        $i.trigger('change');
        log('jQuery triggered change/input on input');
      } catch (e) {
        console.warn('[preSelectNormalOrderVariant] jQuery triggers failed', e);
      }
    }

    // Try to call theme helpers if present and a variant id is available
    let guessedVariant = null;
    guessedVariant = inputEl.dataset?.variantId || inputEl.dataset?.variant || inputEl.getAttribute('data-variant-id') || inputEl.value;
    if (guessedVariant) {
      log('guessedVariant:', guessedVariant);
      // try underscore helper
      try {
        if (window._ && typeof _.setVariant === 'function') {
          const $form = jQuery ? jQuery(inputEl).closest('.product-form') : (inputEl.closest ? inputEl.closest('.product-form') : null);
          if ($form) {
            _.setVariant($form, guessedVariant);
            log('_.setVariant called with', guessedVariant);
          }
        }
      } catch (e) {
        console.warn('[preSelectNormalOrderVariant] _.setVariant error', e);
      }
      // try OptionManager set if exists
      try {
        if (window.theme && theme.OptionManager && typeof theme.OptionManager.selectOptionFromURL === 'function') {
          // build a fake URL with a variant param to reuse existing logic
          const fakeUrl = `${location.pathname}?variant=${encodeURIComponent(guessedVariant)}`;
          const $form = jQuery ? jQuery(inputEl).closest('.product-form') : (inputEl.closest ? inputEl.closest('.product-form') : null);
          theme.OptionManager.selectOptionFromURL(fakeUrl, $form);
          log('theme.OptionManager.selectOptionFromURL used fallback with', guessedVariant);
        }
      } catch (e) {
        console.warn('[preSelectNormalOrderVariant] OptionManager fallback error', e);
      }
    }

    return true;
  }

  // scoped search: prefer the visible quickbuy modal if present
function findInput() {
  // Use jQuery instead of document.querySelector because of :visible
  const $modal = $('.quickbuy-modal.cc-popup--visible, .quickbuy-modal.cc-popup--open:visible').first();
  if (!$modal.length) return null;
  return $modal.find('.normal-preselect-option')[0] || null;
}

  // Try immediate
  const foundNow = findInput();
  if (foundNow) {
    if (tryTrigger(foundNow)) return;
  }

  // Observe for it inside quickbuy modal if present, otherwise observe body
  const observeTarget = document.querySelector('.quickbuy-modal') || document.body;
  log('observing for .normal-preselect-option inside', observeTarget === document.body ? 'document.body' : observeTarget);

  const observer = new MutationObserver((mutations, obs) => {
    const inputEl = findInput();
    if (inputEl) {
      log('mutation observed - element appeared');
      tryTrigger(inputEl);
      obs.disconnect();
    }
  });

  observer.observe(observeTarget, { childList: true, subtree: true });

  // safety stop after 6 seconds
  setTimeout(() => {
    try { observer.disconnect(); } catch (e) {}
    log('observer timeout - stopped watching');
  }, 6000);
};

// call on DOMContentLoaded too (keeps compatibility)
document.addEventListener("DOMContentLoaded", function () {
  window.preSelectNormalOrderVariant();
});






window.preSelectNormalOrderVariantPDP = function () {
  setTimeout(() => {
    const inputEl = document.querySelector(".normal-preselect-option");
    if (inputEl) {
      console.log("find input el", inputEl)
      inputEl.click();
      inputEl.dispatchEvent(
        new CustomEvent("change", { bubbles: true, cancelable: false })
      );
    }

  }, 300);
};

document.addEventListener("DOMContentLoaded", function () {
  window.preSelectNormalOrderVariantPDP();
});
